import { Menu, Radio } from "semantic-ui-react";

import { useRange } from "react-instantsearch";

import Flex from "../../../../components/Flex/Flex";

export default function InstantSearchRefinementBoolean({ attribute, renderItem }) {
	const { refine, canRefine, start } = useRange({ attribute });

	return (
		<>
			<Menu.Item disabled={!canRefine} onClick={() => refine([1, undefined])}>
				<Flex>
					<Radio checked={start[0] === 1} label={renderItem?.(true) || "Yes"} />
				</Flex>
			</Menu.Item>

			<Menu.Item disabled={!canRefine} onClick={() => refine([0, 0])}>
				<Flex>
					<Radio checked={start[1] === 0} label={renderItem?.(false) || "No"} />
				</Flex>
			</Menu.Item>
		</>
	);
}
